/**
 * Полные названия категорий для показа (задача владельца 28.10.2026): ключи категорий в данных прежние
 * («Качество медпомощи»), а юрист видит название без сокращений. Тот же словарь — в apps/api/src/domain/categoryMatrix.ts.
 */

const CATEGORY_LABELS: Readonly<Record<string, string>> = {
    'Запрос меддокументов': 'Запрос медицинских документов',
    'Качество медпомощи': 'Качество медицинской помощи',
    'Организация и доступность медпомощи': 'Организация и доступность медицинской помощи',
    'ЧП / смерть / экстренная помощь': 'Чрезвычайное происшествие / смерть пациента / экстренная медицинская помощь',
};

/** Название категории для показа; незнакомое имя — как есть. */
export function categoryLabel(name: string | null | undefined): string {
    if (!name) return '';
    return CATEGORY_LABELS[name] ?? name;
}
